/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderPlanTransportLotUpdateBase } from './OrderPlanTransportLotUpdateBase';
import {
    OrderPlanTransportLotUpdateBaseFromJSON,
    OrderPlanTransportLotUpdateBaseFromJSONTyped,
    OrderPlanTransportLotUpdateBaseToJSON,
    OrderPlanTransportLotUpdateBaseToJSONTyped,
} from './OrderPlanTransportLotUpdateBase';

/**
 * 
 * @export
 * @interface OrderPlanTransportLotUpdate
 */
export interface OrderPlanTransportLotUpdate {
    /**
     * 
     * @type {OrderPlanTransportLotUpdateBase}
     * @memberof OrderPlanTransportLotUpdate
     */
    body: OrderPlanTransportLotUpdateBase;
}

/**
 * Check if a given object implements the OrderPlanTransportLotUpdate interface.
 */
export function instanceOfOrderPlanTransportLotUpdate(value: object): value is OrderPlanTransportLotUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function OrderPlanTransportLotUpdateFromJSON(json: any): OrderPlanTransportLotUpdate {
    return OrderPlanTransportLotUpdateFromJSONTyped(json, false);
}

export function OrderPlanTransportLotUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPlanTransportLotUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': OrderPlanTransportLotUpdateBaseFromJSON(json['body']),
    };
}

export function OrderPlanTransportLotUpdateToJSON(json: any): OrderPlanTransportLotUpdate {
    return OrderPlanTransportLotUpdateToJSONTyped(json, false);
}

export function OrderPlanTransportLotUpdateToJSONTyped(value?: OrderPlanTransportLotUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': OrderPlanTransportLotUpdateBaseToJSON(value['body']),
    };
}

